import { Box, SizableText, SmartLink, YStack, colors, shadowStandard } from '@my/ui'
import { WriteForUsBlock } from './write-for-us.block'
import { ChevronRight } from '@tamagui/lucide-icons'

export const WriteForUsComponent = (block: WriteForUsBlock) => {
  return (
    <SmartLink Component={Box} href="/write-for-us" pressable>
      <YStack flexShrink={1} pr="$6">
        <SizableText size="$8" fow="800">
          Write for us!
        </SizableText>
        <SizableText size="$4" fow="500" color="$overlay11">
          Are you an aspiring writer or journalist? Have an interesting story about Uni life you
          want to pitch? Or are you passionate about meme’s and want to share your favourites? We’d
          love to hear from you!
        </SizableText>
      </YStack>
      <YStack
        br={1000}
        p="$2.5"
        jc="center"
        ai="center"
        bg="$white"
        width={36}
        height={36}
        {...shadowStandard}
      >
        <ChevronRight color={colors.primary} width={36} height={36} />
      </YStack>
    </SmartLink>
  )
}
